module.exports = __webpack_public_path__ + "img/91289.60a74159.svg";